import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from '../authorize.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AdalService } from 'adal-angular4';
import { RepositoryService } from './../../app/shared/services/repository.service';
import { RiskUser } from './../../app/_interfaces/RiskUser.model';

@Component({
  selector: 'app-login-menu',
  templateUrl: './login-menu.component.html',
  styleUrls: ['./login-menu.component.css']
})
export class LoginMenuComponent implements OnInit {
  public isAuthenticated: Observable<boolean>;
  public userName: string; // Observable<string>;

  constructor(private authorizeService: AuthorizeService, private adalService: AdalService, private repository: RepositoryService) { }

  ngOnInit() {
    this.isAuthenticated = this.adalService.userInfo.authenticated; 
    this.userName = this.adalService.userInfo.profile.given_name; // this.adalService.userInfo.userName;
    this.repository.SetUpMyUser();

  }
}
